var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.urlImage)?_c('img',{attrs:{"src":_vm.icoWooCommerce,"alt":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }